import React from 'react';
import { Tooltip } from 'antd';
import type { TKlarityPayer } from 'types/credentialing';
import s from './s.module.less';

// #19：payer 列表带 providerId 时，available=false 表示该 provider 的执照不能选（后端规则表判断）
export const isPayerUnavailable = (p?: Pick<TKlarityPayer, 'available'> | null) => p?.available === false;

// 原型 blockedPayerCardHTML（10/26）：黄色 tag "Not available for your license"，原因藏在 tag 里的
// tooltip 图标后面，卡片保持一行；卡片本身置灰不可点
export default function PayerUnavailableTag({ reason }: { reason?: string | null }) {
    return (
        <span className={s.tag}>
            Not available for your license
            {reason && (
                <Tooltip title={reason}>
                    <span className={s.tip} onClick={(e) => e.stopPropagation()}>
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            width="13"
                            height="13"
                            aria-hidden
                        >
                            <circle cx="12" cy="12" r="9.5" />
                            <path d="M9.6 9.2a2.4 2.4 0 1 1 3.3 2.2c-.7.4-1.1 1-1.1 1.8" />
                            <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                    </span>
                </Tooltip>
            )}
        </span>
    );
}
